import PageHeader from "../components/pageHeader";
import PillarCards from "../components/pillarCards";
import { useTranslation } from "../../../i18n/useTranslation";

const About = () => {
  const { t } = useTranslation();
  const h = t("deviceworks.pageHeaders.about");
  return (
    <div>
      <PageHeader eyebrow={h.eyebrow} title={h.title} />
      <div className="max-w-2xl mx-auto px-5 py-16 text-center">
        <p className="dw-mini">
          [Placeholder — founder narrative] DeviceWorks was started with a simple
          observation: operations teams managing device fleets were spending more time
          coordinating vendors than actually running their business. Every device category
          had its own OEM, its own support line, and its own SLA — and nobody owned the
          outcome end to end. DeviceWorks exists to be that one accountable partner, backed
          by a network of specialist execution partners and a platform that ties it all together.
        </p>
      </div>
      <div className="dw-panel-bg border-t py-16 px-5" style={{ borderColor: "var(--dw-line)" }}>
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <div className="dw-eyebrow mb-2">What We Stand On</div>
            <h2>Four pillars</h2>
          </div>
          <PillarCards />
        </div>
      </div>
    </div>
  );
};

export default About;
